export const OWCC_HTTP_HEADER = {
  ABTEST_USERGROUP: 'x-owcc-usergroup',
  CARL_LABEL: 'x-owcc-carllabel',
  OWCC_VERSION: 'x-owcc-appversion',
  CONFIGURATION_DATE: 'x-owcc-configurationdate',
  SALESLEVEL: 'x-owcc-saleslevel',
  ZIPCODE: 'x-owcc-zipcode',
  FORMATTING_TAG: 'x-owcc-formattingtag'
};

export const B2X_HTTP_HEADER = {
  AUTH_STATE: 'X-B2XCORE_USER_LOGIN'
};

export const OCAPI_HTTP_HEADER = {
  API_KEY: 'X-API-KEY'
};
